import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { createZeePersonaData } from '@/actions/zee-persona-data/createZeePersonaData';
import { GetZeePersonaDataApiResponse } from '@/actions/zee-persona-data/getZeePersonaData';
import { ApiResponse } from '@/types/response.type';
import { CreateZeePersonaDataPayload } from '@/types/zee-persona-data.type';

export interface UseCreateZeePersonaDataReturn {
  mutate: (
    payload: CreateZeePersonaDataPayload
  ) => Promise<ApiResponse<GetZeePersonaDataApiResponse> | undefined>;
  result: ApiResponse<GetZeePersonaDataApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateZeePersonaData = (): UseCreateZeePersonaDataReturn => {
  const queryClient = useQueryClient();

  const mutation: UseMutationResult<
    ApiResponse<GetZeePersonaDataApiResponse> | undefined,
    Error,
    CreateZeePersonaDataPayload
  > = useMutation({
    mutationFn: (payload) => createZeePersonaData(payload),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['zee-persona-data', variables.user_id],
      });
    },
  });

  return {
    mutate: (payload) => mutation.mutateAsync(payload),
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
